
import Client from "shopify-buy";

import "slick-carousel/slick/slick";
import "slick-lightbox/dist/slick-lightbox";

/* eslint-disable-next-line */
(function ($, shopify_api_config) {

	$(document).ready(function () {

		const client = Client.buildClient({
			domain: shopify_api_config.domain,
			storefrontAccessToken: shopify_api_config.storefront_access_token,
		});

		let existingCartId = "";

		let existingCartCookie = document.cookie
									.split("; ")
									.find((row) => {
										return row.startsWith("rc_shopify_cart_id");
									});

		if(existingCartCookie){
			// Regular expression splits the string on the first occurence of '=', giving us the cookie's value
			existingCartId = existingCartCookie.match(/=(.+)/)[1];
		}

		if($("[data-shopify-product-handle]").length > 0){

			$("[data-shopify-product-handle]").each(function(){

				let productHandle = $(this).data("shopify-product-handle");

				let productCard = $(this);

				//let currCurrency = "CAD";

				// On add to card button click, add product to cart and open modal window
				$(this).find(".js-add-to-cart-btn").on("click", function(evt){

					let variantSelect = productCard.find(".js-product-variant-select");
					let quantityField = productCard.find(".js-product-quantity-field");

					// Only add the product to the cart if a product variant or quantity greater than 0 has been selected
					if(variantSelect.val() || parseInt(quantityField.val()) > 0){

						$(this).prop("disabled", true).addClass("loading");

						let quantity = (quantityField.length > 0) ? parseInt(quantityField.val()) : 1;

						let variantId = "";

						if(variantSelect.length > 0){

							variantId = variantSelect.val();

						}else{

							variantId = quantityField.data("variant-id");

						}

						addItemToCart(variantId, quantity).then(() => {

							$(this).prop("disabled", false).removeClass("loading");

							//console.log("SHOWING MODAL");
							$($(evt.target).data("target")).modal("show");

						});

					}

					// Halt opening of modal window until request to add product to cart is completed
					evt.preventDefault();
					return false;

				});

				$(this).find(".js-product-variant-select").on("change", function(){

					productCard.find(".product-price").text(formatPrice($(this).children(":selected").data("price")));

				});

				client.product.fetchByHandle(productHandle).then((product) => {

					//console.log(product);

					productCard.find(".product-name").text(product.title);

					if(product.description){
						productCard.find(".product-description").html(product.descriptionHtml);
					}

					if(product.images.length > 1){

						productCard.find(".product-image-column")
							.append(
								$("<div>")
									.addClass("product-image-slider")
							);

						productCard.find(".product-image-slider").slick({
							"autoplay":     true,
							//"infinite":     false,
							"dots":         true,
							"draggable":    false,
						});

						productCard.find(".product-image-slider").slickLightbox({
							src: "src",
							itemSelector: "div img",
						});

						product.images.forEach((imageObj) => {

							let imgTag = '<img src="' + imageObj.src + '" alt="' + imageObj.altText + '">';

							productCard.find(".product-image-slider").slick("slickAdd", '<div>' + imgTag + '</div>');

						});

					}else if(product.images.length > 0){

						productCard.find(".product-image-column")
							.append(
								$("<img>")
									.addClass("product-image")
									.attr("src", product.images[0].src)
									.attr("alt", product.images[0].altText)
							);

					}

					product.variants.forEach((variant, index) => {

						if(index === 0){
							productCard.find(".product-price").text(formatPrice(variant.price.amount));
							productCard.find(".js-product-quantity-field").data("variant-id", variant.id);
						}

						productCard.find(".js-product-variant-select").append($("<option>", {
							value:          variant.id,
							text:           variant.title,
							"data-price":   convertPriceStringToInt(variant.price.amount),
						}));

					});

					productCard.find(".loader").hide();

				});

			});

		}

		// Listener that fires when cart modal is opened
		$("#shopify-cart-modal").on("show.bs.modal", function(evt){

			let thisModalContent = $(evt.target).find(".modal-content");

			getCartObj().then((cartObj) => {

				//console.log("CART CONTENTS");
				//console.log(cartObj);
				populateCartModal(thisModalContent, cartObj);

			});

			thisModalContent.on("click", ".cart-item-remove-btn", function(){

				let productIdToDelete = $(this).data("cart-item-id");

				// Send request to Shopify to remove product from cart
				client.checkout.removeLineItems(existingCartId, [productIdToDelete]).then((updatedCart) => {

					populateCartModal(thisModalContent, updatedCart);

					updateCartIconIndicators(updatedCart);
					updateCartCookie(updatedCart.id);

					CART_GLOBAL = updatedCart;

				});

			});

			thisModalContent.on("change", ".js-cart-item-quantity-field", function(){

				let quantity = parseInt($(this).val());

				if(quantity < 1){

					quantity = 1;

					$(this).val(quantity);

				}

				if(quantity > 100){

					quantity = 100;

					$(this).val(quantity);

				}

				let lineItemIdToUpdate = $(this).data("cart-item-id");

				let lineItemToUpdate = {id: lineItemIdToUpdate, quantity: quantity};

				let thisQuantityField = $(this);

				// Send request to Shopify to update item's quantity
				client.checkout.updateLineItems(existingCartId, [lineItemToUpdate]).then((updatedCart) => {

					updatedCart.lineItems.forEach(function(cartItem){

						if(cartItem.id === lineItemIdToUpdate){

							let lineItemUnitPrice = convertPriceStringToInt(cartItem.variant.price.amount);

							let lineItemTotal = lineItemUnitPrice * quantity;

							thisQuantityField.closest(".cart-list-item").find(".cart-item-price").html(formatPrice(lineItemTotal))

						}

					});

					thisModalContent.find(".cart-sub-total-amount").text(formatPrice(updatedCart.subtotalPrice.amount));

					updateCartCookie(updatedCart.id);

					CART_GLOBAL = updatedCart;

				});

			});

			thisModalContent.find(".cart-checkout-btn").on("click", function(){

				$(this).prop("disabled", true).addClass("loading");

				getCartObj().then((cartObj) => {

					//$(this).prop("disabled", false).removeClass("loading");

					if(cartObj != null){
						window.open(cartObj.webUrl, "_self");
					}

				});

			});

		});

		let CART_GLOBAL = null;

		let getCartObj = function(){

			if((CART_GLOBAL == null) && (existingCartId !== "")){

				return new Promise((resolve, reject) => {

					client.checkout.fetch(existingCartId)
						.then((cart) => {

							// Check if cart has been checked out and completed
							if(cart.completedAt !== null){

								updateCartCookie(cart.id, true);

								existingCartId = "";
								CART_GLOBAL = null;

							// If the cart is still active, save the cart to the global variable
							}else{

								CART_GLOBAL = cart;

							}

							resolve(cart);

						})
						.catch((error) => {
							reject(error);
						});

				});

			}else{

				return Promise.resolve(CART_GLOBAL);

			}

		};

		let updateCartCookie = function(cartId, remove = false){

			var cookieExpirySeconds = (remove) ? 0 : 60 * 60 * 24 * 14;

			document.cookie = "rc_shopify_cart_id=" + cartId + "; max-age=" + cookieExpirySeconds + "; path=/";

		};

		let addItemToCart = function(variantId, quantity = 1){

			let addToCartPromise = Promise.resolve();

			if(existingCartId === ""){
				//console.log("CREATING CART");
				addToCartPromise = client.checkout.create().then((checkout) => {
					//console.log("SAVING CREATED CART");
					existingCartId = checkout.id;

				});

			}

			return addToCartPromise.then(() => {
				//console.log("ADDING ITEM TO CART");
				const lineItemData = [
					{
						variantId: variantId,
						quantity: quantity,
					},
				];
				//console.log(existingCartId);
				//console.log(lineItemData);
				return client.checkout.addLineItems(existingCartId, lineItemData).then((updatedCart) => {
					//console.log("ADDED ITEM TO CART. UPDATING CART COOKIE");
					updateCartIconIndicators(updatedCart);
					updateCartCookie(updatedCart.id);

					CART_GLOBAL = updatedCart;

				});

			});

		};

		let updateCartIconIndicators = function(cart){

			$(".btn-cart").each(function(){

				//console.log("ADDING CART ICON INDICATOR");
				//console.log(cart);

				if(cart.lineItems.length > 0){

					/*if($(this).children(".num-cart-items").length === 0){
						$(this).append($("<span>").addClass("num-cart-items"));
					}

					$(this).children(".num-cart-items").text(cart.lineItems.length);*/

					$(this).addClass("cart-has-items");

				}else{

					//$(this).children(".num-cart-items").remove();

					$(this).removeClass("cart-has-items");

				}

			});

		};

		if($(".btn-cart").length > 0){

			getCartObj().then((cartObj) => {

				if(cartObj != null){
					updateCartIconIndicators(cartObj);
				}

			});

		}

	});

	function populateCartModal(modal, cartData){
		//console.log(modal);
		//console.log(cartData);
		modal.find(".cart-items-list").html("");
		modal.find(".cart-sub-total-amount").text("$0.00");

		//let strippedCartItemData = {};

		if((cartData != null) && (cartData.lineItems.length > 0)){

			cartData.lineItems.forEach(function(cartItem){

				let lineItemUnitPrice = convertPriceStringToInt(cartItem.variant.price.amount);

				let lineItemTotal = lineItemUnitPrice * cartItem.quantity;

				let cartItemLI = $("<li>")
					.addClass("cart-list-item")
					/*.append(
						$("<img>")
							.addClass("img-fluid")
							.attr("src", cartItem.variant.image.src)
							.attr("alt", cartItem.variant.image.altText)
					)*/
					.append(
						$("<div>")
							.addClass("cart-item-info")
							.append(
								$("<p>")
									.addClass("cart-item-description")
									.html(cartItem.title + " - " + cartItem.variant.title)
							)
							.append(
								$("<p>")
									.addClass("cart-item-quantity")
									.html("Quantity: ")
									.append(
										$("<input>")
											.attr("type", "number")
											.addClass("form-control js-cart-item-quantity-field")
											.val(cartItem.quantity)
											.data("cart-item-id", cartItem.id)
									)
							)
							.append(
								$("<div>")
									.addClass("cart-item-actions")
									.append(
										$("<button>")
											.attr("type", "button")
											.addClass("btn btn-link cart-item-remove-btn")
											.data("cart-item-id", cartItem.id)
											.text("Remove")
									)
							)
					)
					.append(
						$("<div>")
							.addClass("cart-item-price")
							.html(formatPrice(lineItemTotal))
					);

				modal.find(".cart-items-list").append(cartItemLI);

			});

			modal.find(".cart-sub-total-amount").text(formatPrice(cartData.subtotalPrice.amount));

			modal.find(".cart-checkout-btn").prop("disabled", false);

		}else{

			modal.find(".cart-items-list").html('<li><h5>Your cart is currently empty</h5></li>');

			modal.find(".cart-checkout-btn").prop("disabled", true);

		}

	}

	function formatPrice(price){

		if(typeof price === "string"){
			price = convertPriceStringToInt(price);
		}

		return "$" + (price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

	}

	function convertPriceStringToInt(priceStr){

		if(priceStr.match(/\.\d$/) != null){
			priceStr += "0";
		}

		return parseInt(priceStr.replace(/[.,]/g, ""));
	}

	/* eslint-disable-next-line */
})(jQuery, shopify_api_config);